import { render, staticRenderFns } from "./BxInventoryStatus.vue?vue&type=template&id=abed3dde&"
import script from "./BxInventoryStatus.vue?vue&type=script&lang=js&"
export * from "./BxInventoryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports